export default {
  dashboard: {
    label: 'Bảng điều khiển',
  },
}
